<sh-context-menu #menu>
  <ng-container *ngFor="let item of basicMenu" >
    <ng-template shContextMenuItem let-data let-close="close" (click)="menuClick($event, item.label)">
      <div>
        {{ item.label | translate }}
      </div>
    </ng-template>
  </ng-container>
</sh-context-menu>